import React, { useEffect, useState } from 'react';
import Badge from './Badge';
import { TbCaretDownFilled, TbCircleCheck, TbClock } from 'react-icons/tb';
import { formatCartId } from '../../Utils/Formatters';
import { getOrderColorByStatusId, getOrderTypeLabelById } from '../../Utils/Constants/Order';
import { isOrderOpen } from '../../Utils/Helpers';
import { ORDER_TYPE_ICONS_BY_ID, ORDER_TYPE_STORE_COUNTER_ID } from '../../Utils/Constants/Service';
import { useTranslation } from 'react-i18next';
import { MdOutlineTableRestaurant } from 'react-icons/md';

interface CardOrderTodayProps {
  order: any;
  onClick: CallableFunction;
}

const CardOrderToday = ({
  order,
  onClick,
}: CardOrderTodayProps) => {

    const { t } = useTranslation();
    const [showItems, setShowItems] = useState(false);
    const isMuted = !isOrderOpen(order);

    const IconOrderType = ORDER_TYPE_ICONS_BY_ID[order.type as keyof typeof ORDER_TYPE_ICONS_BY_ID];

    useEffect(() => {
        setShowItems(!isMuted);
    }, [isMuted])

    const displayCode = order.type === ORDER_TYPE_STORE_COUNTER_ID
                            ? order.cart_display_id ?? order.cart_id
                            : order.id;

    return (
        <div className={`flex justify-between gap-1.5`}>
            <div className={`flex gap-2 items-center justify-between w-full p-4 rounded-lg self-start transition-all ease-in-out ${isMuted ? `ring-1 ring-gray-200 ${showItems ? 'bg-white' : ''}` : `bg-white shadow`}`}>
                <div className="grid gap-1.5 w-full">
                    <div className="flex items-center gap-3 cursor-pointer" onClick={() => onClick()}>
                        <div className={`text-3xl tracking-tighter font-bold leading-none text-shopfood-${getOrderColorByStatusId(Number(order.status))}`}>{ formatCartId(displayCode) }</div>
                        <div className='grid gap-0.5'>

                            {order.type &&
                                <div className='flex items-center gap-0.5 leading-none text-sm font-bold normal-case'>
                                    <span>{getOrderTypeLabelById(order.type)}</span>
                                    {order.cart_pdv_validation && order.type === ORDER_TYPE_STORE_COUNTER_ID && <span><TbCircleCheck /></span>}
                                </div>
                            }

                            {order.table &&
                                <div className='inline-flex items-center gap-0.5 font-medium text-xs leading-none mb-0.5'>
                                    <span className='text-sm'><MdOutlineTableRestaurant /></span>
                                    {order.table?.name}
                                </div>
                            }

                            <div className="flex items-center gap-2 text-gray-400 text-xs">
                                <span className='inline-flex items-center gap-0.5 text-sm font-medium leading-none'><TbClock />{order.created_at_time_formatted}</span>
                                <span className='text-[.9em] leading-none'>{order.created_at_date_formatted}</span>
                            </div>

                        </div>
                    </div>

                    <div className='flex gap-2'>
                        <Badge outline className="text-xs leading-none py-1" type={getOrderColorByStatusId(Number(order.status))}>{order.status_name}</Badge>

                        {order.items &&
                            <button onClick={() => setShowItems(!showItems)} className="flex items-center gap-0.5 h-full text-xs leading-none font-medium text-nowrap text-gray-400">
                                <span><TbCaretDownFilled className={`transition-transform duration-300 ${showItems ? '-rotate-180' : ''}`} /></span>
                                {showItems ? t('layout.today_orders_hide_info') : t('layout.today_orders_show_info')}
                            </button>
                        }
                    </div>

                    {order.items &&
                        <div className='flex flex-col self-start gap-2' onClick={() => onClick()}>
                            <div className={`grid divide-y divide-gray-100 text-sm text-gray-500 leading-none transition-all overflow-y-auto ease-in-out duration-200 ${showItems ? 'opacity-100 max-h-[35dvh] px-0.5 pt-2' : 'opacity-0 max-h-0'}`}>
                                {order.items?.map((item: any, index: number) =>
                                    <div key={index} className="flex justify-between leading-none text-xs py-1 gap-1">
                                        <div className="flex">
                                            <span className="min-w-6">{item.quantity}x</span>
                                            <span>{item.name}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }

                </div>
            </div>
            <div onClick={() => onClick()} className={`relative grid items-center p-4 rounded-lg cursor-pointer transition-all ease-in-out ${isMuted ? `ring-1 ring-gray-200 ${showItems ? 'bg-white' : ''}` : 'bg-white shadow'}`}>
                <div className={`w-1.5 h-6 absolute -left-1.5 top-1/2 -translate-y-1/2 border-y transition-all ease-in-out ${isMuted ? `border-gray-200 ${showItems ? 'bg-white' : 'bg-gray-50'}` : 'bg-white'}`}></div>

                {IconOrderType &&
                    <div className={`w-10 flex flex-col items-center justify-center ${isMuted ? 'opacity-45' : 'text-shopfood-title'}`}>
                        <IconOrderType size={isMuted ? 30 : 40} />
                    </div>
                }
            </div>
        </div>
    )
}

export default CardOrderToday;